import ShopCategoryList from '../../slices/shop/shop-category/ShopCategoryList'
import ShopCategoryDetails from '../../slices/shop/shop-category/ShopCategoryDetails'
import ShopSubCategoryList from '../../slices/shop/shop-sub-category/ShopSubCategoryList'
import ShopSubCategoryDetails from '../../slices/shop/shop-sub-category/ShopSubCategoryDetails'
import ShopProductList from '../../slices/shop/shop-product/ShopProductList'
import ShopProductDetails from '../../slices/shop/shop-product/ShopProductDetails'

const shopReducer = {
    shopCategoryList: ShopCategoryList,
    shopCategoryDetails: ShopCategoryDetails,
    shopSubCategoryList: ShopSubCategoryList,
    shopSubCategoryDetails: ShopSubCategoryDetails,
    shopProductList: ShopProductList,
    shopProductDetails: ShopProductDetails,
};

export default shopReducer;
